import { Box, Container, Typography } from "@mui/material";
import React from "react";
import {
  colorApp,
  colorBg,
  colorBlack,
  smTitleStyle,
  SvgComponent,
  textStyle,
  titleStyle,
} from "../../../Resources/Design/theme";
import { getSocials } from "../../../Components/Navbar";
import { Motion } from "../../../Components/Motion";

const iconSize = "40px";

export default function Contact() {
  return (
    <Container
      maxWidth="lg"
      sx={{
        display: "flex",
        my: { xs: "60px", sm: "90px", md: "90px" },
      }}
      id="contact"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            ...smTitleStyle,
            color: colorApp,
            textAlign: "left",
            //pt: "60px",
          }}
        >
          Kontakty
        </Typography>
        <Typography
          sx={{
            ...titleStyle,
            color: colorApp,
            textAlign: "left",
            mt: "14px",
          }}
        >
          Kde nás najdete?
        </Typography>
        <Typography
          sx={{
            ...textStyle,
            color: colorBlack,
            textAlign: "left",
            mt: "14px",
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            mr: "32px",
          }}
        >
          Pokud máte jakýkoliv dotaz, neváhejte nás kontaktovat!
          <br />
          Preferujeme komunikaci přes e-mail{" "}
          <a
            href="mailto:projectmatthews2025@gmail.com"
            style={{ textDecoration: "none", color: colorBlack }}
          >
            <b>projectmatthews2025@gmail.com</b>
          </a>
        </Typography>
        <Box
          sx={{
            mr: "auto",
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            mt: "24px",
          }}
        >
          {getSocials({}, {}).map((data, i) => (
            <Motion key={`ContactMot` + i}>
              <Box sx={{ mr: "12px" }}>
                <Box
                  component={"a"}
                  href={data.link}
                  target="_blank"
                  sx={{
                    height: iconSize,
                    maxHeight: iconSize,
                    cursor: "pointer",
                  }}
                >
                  <SvgComponent
                    svg={data.icon}
                    style={{
                      width: iconSize,
                      height: iconSize,
                      color: colorApp,
                    }}
                    sx={{
                      maxHeight: iconSize,
                    }}
                  />
                </Box>
              </Box>
            </Motion>
          ))}
        </Box>
      </Box>
    </Container>
  );
}
